module.exports = __webpack_public_path__ + "static/media/plus-disabled.9f368eec.svg";